import React, {useEffect, useState} from "react";
import {Autocomplete, Box, Button, IconButton, Stack, TextField, Typography} from "@mui/material";
import Modal from "@mui/material/Modal";
import moment from "moment/moment";
import {IconX} from "@tabler/icons-react";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "sm", width: {xs: "90%", md: "70%"},
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 2,
  border: '0px solid #000',
  boxShadow: 24,
  px: 4,
  py: 3,
  overflowY: "auto",
};

export const FilterModal = ({filters, setFilters, open, handleClose, project}) => {
  const [newFilters, setNewFilters] = useState({...(filters || {})});

  useEffect(() => {
    if (open && filters) {
      setNewFilters({...(filters || {})});
    }
  }, [open, filters]);


  const onClose = () => {
    handleClose();
    setNewFilters({})
  }

  const onSuccess = () => {
    setFilters({...newFilters});
    handleClose();
  }

  const onReset = () => {
    setFilters({});
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={{...style}}>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant={"h5"} fontWeight={600}>Conversation Filter</Typography>
          <Box>
            <IconButton
              variant={"outlined"}
              color={"secondary"}
              sx={{borderRadius: 1, textTransform: "capitalize"}}
              onClick={onClose}
            >
              <IconX/>
            </IconButton>
          </Box>
        </Stack>

        <Stack direction={"column"} gap={2} sx={{flex: 1, overflowY: "auto"}}>
          <Box>
            <Typography fontWeight={"400"} gutterBottom>Conversation ID</Typography>
            <TextField
              placeholder={"Conversation ID"}
              value={newFilters?.id} fullWidth
              onChange={(e) => setNewFilters(prev => ({...prev, id: e?.target?.value}))}
            />
          </Box>
          <Box>
            <Typography fontWeight={"400"} gutterBottom>Caller Phone Number</Typography>
            <TextField
              placeholder={"Phone Number (ex. 0038970123123)"}
              value={newFilters?.caller} fullWidth
              onChange={(e) => setNewFilters(prev => ({...prev, caller: e?.target?.value}))}
            />
          </Box>
          <Stack direction={"row"} gap={2}>

            <Box sx={{flex: 1}}>
              <Typography fontWeight={"400"} gutterBottom>Start Date</Typography>
              <TextField
                type={"date"} fullWidth
                placeholder={"Start Date"}
                value={newFilters.start || ""}
                inputProps={{
                  max: moment(newFilters?.end || new Date()).format("YYYY-MM-DD")
                }}
                onChange={(e) => {
                  const newValue = e?.target?.value;
                  console.log(newValue);
                  setNewFilters((prev) => ({ ...prev, start: newValue }));
                }}
              />
            </Box>
            <Box sx={{flex: 1}}>
              <Typography fontWeight={"400"} gutterBottom>End Date</Typography>
              <TextField
                type={"date"}
                placeholder={"Start Date"}
                fullWidth
                value={newFilters.end || ""}
                inputProps={{
                  min: newFilters?.start ? moment(newFilters?.start).format("YYYY-MM-DD") : undefined,
                  max: moment(new Date()).format("YYYY-MM-DD")
                }}
                onChange={(e) => {
                  const newValue = e?.target?.value;
                  console.log(newValue);
                  setNewFilters((prev) => ({ ...prev, end: newValue }));
                }}
              />
            </Box>
          </Stack>
          <Box>
            <Typography fontWeight={"400"} gutterBottom>Transfer Number (VDN)</Typography>
            <TextField
              placeholder={"Extension (965)"}
              value={newFilters?.vdn} fullWidth
              onChange={(e) => setNewFilters(prev => ({...prev, vdn: e?.target?.value}))}
            />
          </Box>
          <Box>
            <Typography fontWeight={"400"} gutterBottom>Status</Typography>
            <Autocomplete
              value={newFilters.status || null}
              onChange={(event, newValue) => {
                setNewFilters(prev => ({ ...prev, status: newValue }));
              }}
              options={["ACTIVE", "FINISHED", "REDIRECTED", "FAILED", "HANDOVER", "HANGUP", "MISSED_CALL"]}
              clearOnEscape
              freeSolo={false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Status"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </Box>

          <Box>
            <Typography fontWeight={"400"} gutterBottom>Conversation with tag</Typography>
            <Autocomplete
              multiple
              value={newFilters.tagIn || []}
              onChange={(event, newValue) => {
                setNewFilters(prev => ({ ...prev, tagIn: newValue || [] }));
              }}
              options={project?.settings?.tags}
              getOptionLabel={(option) => option?.name}
              isOptionEqualToValue={(option, value) => (option?.id || option) === (value?.id || value)}
              // clearOnEscape
              freeSolo={false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Conversation with tag"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </Box>

          <Box>
            <Typography fontWeight={"400"} gutterBottom>Conversation without tag</Typography>
            <Autocomplete
              multiple
              value={newFilters.tagNotIn || []}
              onChange={(event, newValue) => {
                setNewFilters(prev => ({ ...prev, tagNotIn: newValue || [] }));
              }}
              options={project?.settings?.tags}
              getOptionLabel={(option) => option?.name}
              isOptionEqualToValue={(option, value) => (option?.id || option) === (value?.id || value)}
              // clearOnEscape
              freeSolo={false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Conversation without tag"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </Box>

        </Stack>
        <Stack direction={"row"} gap={1} justifyContent={"flex-end"}>

          <Box>
            <Button
              variant={"ghost"}
              color={"secondary"}
              sx={{borderRadius: 1, textTransform: "capitalize"}}
              onClick={onReset}
              disabled={Object.values(newFilters)?.filter(i => !!i)?.length === 0}
            >
              Clear
            </Button>
          </Box>
          <Box>
            <Button
              variant={"modal"}
              color={"secondary"}
              sx={{borderRadius: 1, textTransform: "capitalize"}}
              onClick={onSuccess}
            >
              Save
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Modal>
  )
}